/* eslint-disable no-console */
import {
  WrapConfigureLabel,
  StyledPopupFontColor,
  StyledPopupOutlineColor,
} from './styles';

import ColorPicker from './components/ColorPicker';

import Icon from '@map/components/Icons';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useEffect, useState } from 'react';

const ConfigureLabel = ({ initialValues, onFormConfigureLabel, onClose }) => {
  const [anchorElFontColor, setAnchorElFontColor] = useState(null);
  const [anchorElOutlineColor, setAnchorElOutlineColor] = useState(null);
  const [fontColor, setFontColor] = useState(false);
  const [outlineColor, setOutlineColor] = useState(false);
  const [fontBold, setFontBold] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [alignLabel, setAlignLabel] = useState('center');

  /**
   * Manuseia o submit do formulário
   *
   */
  const handleSubmitForm = () => {
    onFormConfigureLabel &&
      onFormConfigureLabel(
        fontColor,
        outlineColor,
        fontBold,
        fontSize,
        alignLabel
      );
    onClose && onClose();
  };

  /**
   * Abre popup do componente de cores para fonte
   *
   * @param {object} event
   */
  const openPopupFontColor = (event) => {
    setAnchorElFontColor(event.currentTarget);
  };

  /**
   * Fecha o popup do componente de cores da fonte
   */
  const handleClosePopupFontColor = () => {
    setAnchorElFontColor(null);
  };

  /**
   * Persiste cor selecionada da fonte
   *
   * @param {string} fontColor
   */
  const onFormSelectFontColor = (paramFontColor) => {
    setFontColor(paramFontColor);
  };

  /**
   * Abre popup do componente de cores para contorno da fonte
   *
   * @param {object} event
   */
  const openPopupOutlineColor = (event) => {
    setAnchorElOutlineColor(event.currentTarget);
  };

  /**
   * Fecha o popup do componente de cores do contorno da fonte
   */
  const handleClosePopupOutlineColor = () => {
    setAnchorElOutlineColor(null);
  };

  /**
   * Persiste cor selecionada da fonte
   *
   * @param {string} fontColor
   */
  const onFormSelectOutlineColor = (paramOutlineColor) => {
    setOutlineColor(paramOutlineColor);
  };

  /**
   * Manuseia negrito da fonte
   */
  const handleChangeFontWeight = () => {
    fontBold ? setFontBold(false) : setFontBold(true);
  };

  /**
   * Manuseia tamanho da fonte
   *
   * @param {object} e
   */
  const handleChangeFontSize = (e) => {
    setFontSize(e.target.value);
  };

  /**
   * Manuseia alinhamento do rótulo em relação a feição
   *
   * @param {string} align
   */
  const handleChangeHorizontalAlign = (align) => {
    setAlignLabel(align);
  };

  useEffect(() => {
    if (initialValues) {
      initialValues.selectedFontColor &&
        setFontColor(initialValues.selectedFontColor);
      initialValues.selectedOutlineColor &&
        setOutlineColor(initialValues.selectedOutlineColor);
      initialValues.selectedFontBold &&
        setFontBold(initialValues.selectedFontBold);
      initialValues.selectedFontSize &&
        setFontSize(initialValues.selectedFontSize);
      initialValues.selectedLabelAlign &&
        setAlignLabel(initialValues.selectedLabelAlign);
    }
  }, [initialValues]);

  return (
    <WrapConfigureLabel>
      <div className="config-label-actions active">
        <Tooltip title="Cor da fonte">
          <button className="config-label-action" onClick={openPopupFontColor}>
            <Icon
              i="map-labelmenu-fontcolor"
              width="18"
              height="18"
              fill={fontColor ? fontColor : null}
            />
          </button>
        </Tooltip>
        <Tooltip title="Cor do contorno">
          <button
            className="config-label-action"
            onClick={openPopupOutlineColor}
          >
            <Icon
              i="map-labelmenu-fontcolor"
              width="18"
              height="18"
              fill={outlineColor ? outlineColor : null}
            />
          </button>
        </Tooltip>
        <Tooltip title="Negrito">
          <button
            className="config-label-action"
            onClick={handleChangeFontWeight}
          >
            <Icon
              i="map-labelmenu-fontbold"
              width="18"
              height="18"
              fill={fontBold ? '#3C71DD' : null}
            />
          </button>
        </Tooltip>
        <div className="config-label-action">
          <Select
            className="select"
            labelId="coord-type-label"
            value={fontSize}
            onChange={handleChangeFontSize}
            MenuProps={{ style: { zIndex: 1650 } }}
            IconComponent={(props) => (
              <Icon
                i="map-chevrondown"
                style={{ top: 'auto', right: 2 }}
                {...props}
              />
            )}
          >
            {[
              { label: '8', value: 8 },
              { label: '9', value: 9 },
              { label: '10', value: 10 },
              { label: '11', value: 11 },
              { label: '12', value: 12 },
              { label: '13', value: 13 },
              { label: '14', value: 14 },
              { label: '18', value: 18 },
              { label: '24', value: 24 },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        <Tooltip title="Alinhar à esquerda">
          <button
            className="config-label-align-action"
            onClick={(e) => {
              e.preventDefault();
              handleChangeHorizontalAlign('left');
            }}
          >
            <Icon
              i="map-labelmenu-labelalignleft"
              width="18"
              height="18"
              fill={alignLabel === 'left' ? '#3C71DD' : null}
            />
          </button>
        </Tooltip>
        <Tooltip title="Alinhar ao centro">
          <button
            className="config-label-align-action"
            onClick={(e) => {
              e.preventDefault();
              handleChangeHorizontalAlign('center');
            }}
          >
            <Icon
              i="map-labelmenu-labelalignhorizontalcenter"
              width="18"
              height="18"
              fill={alignLabel === 'center' ? '#3C71DD' : null}
            />
          </button>
        </Tooltip>
        <Tooltip title="Alinhar à direita">
          <button
            className="config-label-align-action"
            onClick={(e) => {
              e.preventDefault();
              handleChangeHorizontalAlign('right');
            }}
          >
            <Icon
              i="map-labelmenu-labelalignright"
              width="18"
              height="18"
              fill={alignLabel === 'right' ? '#3C71DD' : null}
            />
          </button>
        </Tooltip>
        <Tooltip title="Alinhar ao topo">
          <button
            className="config-label-align-action"
            onClick={(e) => {
              e.preventDefault();
              handleChangeHorizontalAlign('top');
            }}
          >
            <Icon
              i="map-labelmenu-labelaligntop"
              width="18"
              height="18"
              fill={alignLabel === 'top' ? '#3C71DD' : null}
            />
          </button>
        </Tooltip>
        <Tooltip title="Alinhar a base">
          <button
            className="config-label-align-action"
            onClick={(e) => {
              e.preventDefault();
              handleChangeHorizontalAlign('bottom');
            }}
          >
            <Icon
              i="map-labelmenu-labelalignbottom"
              width="18"
              height="18"
              fill={alignLabel === 'bottom' ? '#3C71DD' : null}
            />
          </button>
        </Tooltip>
        <div className="save">
          <Button onClick={handleSubmitForm}>Salvar</Button>
        </div>
      </div>
      <StyledPopupFontColor
        anchorEl={anchorElFontColor}
        open={Boolean(anchorElFontColor)}
        onClose={handleClosePopupFontColor}
        anchorOrigin={{
          vertical: -45,
          horizontal: -10,
        }}
      >
        <div className="arrow-font-color-picker"></div>
        <ColorPicker
          onFormSelectColor={onFormSelectFontColor}
          onClose={handleClosePopupFontColor}
          colors={[
            '#ff1744',
            '#d500f9',
            '#2979ff',
            '#18ffff',
            '#76ff03',
            '#ffff00',
            '#ff9100',
            '#e0e0e0',
            '#000000',
          ]}
        />
      </StyledPopupFontColor>
      <StyledPopupOutlineColor
        anchorEl={anchorElOutlineColor}
        open={Boolean(anchorElOutlineColor)}
        onClose={handleClosePopupOutlineColor}
        anchorOrigin={{
          vertical: -45,
          horizontal: -10,
        }}
      >
        <div className="arrow-outline-color-picker"></div>
        <ColorPicker
          onFormSelectColor={onFormSelectOutlineColor}
          onClose={handleClosePopupOutlineColor}
          colors={['#e0e0e0', '#000000']}
        />
      </StyledPopupOutlineColor>
    </WrapConfigureLabel>
  );
};

ConfigureLabel.properties = {
  ignore: true,
};

export default ConfigureLabel;
